import React, {useState} from "react";
import ConfirmModal from "../modal/ConfirmModal";
import IconButton from "./IconButton";


const ConfirmIconButton = ({
                               confirmTitle,
                               confirmDescription,
                               onConfirm,
                               variant,
                               icon,
                               size,
                               tooltip,
                               children,
                               className,
                               disabled,
                               ready,
                               modelChildren,
                               fullIcon,
                               print,
                               alert,
                               form,
                               buttonsConf,
                               modalClassName,
                               additionalFields,
                               modalSize = "sm"
                           }) => {

    const [show, setShow] = useState(false);

    const onClick = () => {
        setShow(true);
    };

    return (
        <>
            <IconButton variant={variant}
                        className={className}
                        disabled={disabled}
                        icon={icon}
                        size={size}
                        tooltip={tooltip}
                        fullIcon={fullIcon}
                        onClick={onClick}>{children}</IconButton>
            <ConfirmModal
                title={confirmTitle}
                description={confirmDescription}
                show={show}
                alert={alert}
                form={form}
                print={print}
                setShow={setShow}
                ready={ready}
                children={modelChildren}
                onConfirm={onConfirm}
                buttonsConf={buttonsConf}
                modalClassName={modalClassName}
                additionalFields={additionalFields}
                size={modalSize}
            />
        </>
    );
};

export default ConfirmIconButton;